export default {
    table: {
        total: 'Итого',
        totalFor: 'Итого по',
    },
};
